import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconUserPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, CifraCargando, Group } from "@/components/ui";

export function UsuariosHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  /** undefined en la primera carga (sin caché) · se pinta una barra en vez de «0». */
  total: number | undefined;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Usuarios"
      description={<>Listado de usuarios del portal con sus roles, áreas asignadas y organizaciones permitidas · <CifraCargando valor={total} /> total.</>}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconUserPlus size={14} />} onClick={onIniciarCrear}>
              Nuevo usuario
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
